import { MenuList } from '@mui/material';
import { useSwimlaneRootProps } from '@/common/components/ui/swimlane/context';
import { StyledContextMenu, useContextMenu } from '@/common/components/ui/swimlane/context-menu';
import type { TCardId } from '@/common/components/ui/swimlane/types';
import { parseCardId } from '@/common/components/ui/swimlane/utils';
import { usePortalContainer } from '@/features/views/components/PortalContainerContext';

import useSLCardContextMenuSlots from './hooks/useSLCardContextMenuSlots';
import { SLCardContextMenuSlot } from './SLCardContextMenuSlot';

export const CardContextMenu = () => {
  const { actions, readOnly, isPublicationMode, isSubItemFeaturesEnabled } = useSwimlaneRootProps();
  const portalContainer = usePortalContainer();
  const { contextMenu, closeContextMenu } = useContextMenu();
  const { itemID, columnID, rowID } = parseCardId(contextMenu.itemID as TCardId);
  const { open, data, anchorEl } = contextMenu;
  const menuSlotsData = useSLCardContextMenuSlots({
    itemID,
    columnID,
    rowID,
    canEdit: !readOnly,
    isPublicationMode,
    itemCardActions: actions?.itemCardActions,
    isDeletable: !!data?.isDeletable,
    isSubItemFeaturesEnabled,
  });

  return (
    <StyledContextMenu
      open={open}
      anchorEl={anchorEl}
      MenuListProps={{
        'aria-labelledby': 'card-menu',
      }}
      onClose={closeContextMenu}
      container={portalContainer}
    >
      <MenuList>
        {menuSlotsData.map((slotData, index) => (
          <SLCardContextMenuSlot
            key={slotData.slot}
            menuSlot={slotData}
            isLast={index === menuSlotsData.length - 1}
            closeContextMenu={closeContextMenu}
          />
        ))}
      </MenuList>
    </StyledContextMenu>
  );
};
